/**
 * QuickRequestShortcut — la entrada al camino rápido, desde donde el técnico ya está.
 *
 * QUÉ PROBLEMA RESUELVE
 * `SmartMaterialRequest` (`/tecnico/materiales/smart`) deja pedir material
 * dictando o sacando una foto, sin llenar campos. Vivía en una ruta a la que no
 * apuntaba nada desde `/tecnico/materiales`: existía y nadie la iba a encontrar.
 *
 * QUÉ **NO** ES ESTO
 * No es una degradación del formulario. `/tecnico/materiales/solicitar` sigue
 * siendo el camino primario por decisión del dueño del producto: el botón
 * "Solicitar Material" se queda arriba, full-width y en color primario. Este
 * bloque va DEBAJO, en outline, y es un atajo — no un reemplazo ni un modo
 * alternativo con el mismo peso.
 *
 * POR QUÉ ESTA FORMA Y NO OTRA
 *
 * · Dos botones con el VERBO, no uno con el nombre de la función. Un solo botón
 *   que dijera "Solicitud inteligente" no enseña nada en un vistazo: es el
 *   nombre interno de la pantalla, y además cae en el modo Texto, que es
 *   justamente teclear — lo que el atajo venía a evitar. "Dictar la lista" y
 *   "Tomarle una foto" dicen qué hace distinto y entran directo a ese modo
 *   (`?modo=dictar` / `?modo=foto`, ver `SmartMaterialRequest`).
 *
 * · Lado a lado, no apilados. Es la excepción justificada a "un control por fila
 *   en el teléfono": a 375px cada botón queda en ~165×72px, muy por encima del
 *   piso de 44px, y los dos entran sin scroll debajo del botón primario. La
 *   regla de apilar existe para inputs que se truncan (fechas, horas, texto);
 *   acá no hay nada que truncar.
 *
 * · Nada de tabs/segmented control arriba de `/tecnico/materiales`. Eso
 *   convertiría al formulario en uno de dos modos pares y cambiaría lo que la
 *   ruta ES. La decisión fue la contraria.
 *
 * · Nada de kebab ni menú desplegable. Es una afordancia escondida: un toque de
 *   más para descubrir algo que hoy nadie descubre, y un target chico con
 *   guantes.
 *
 * · Sin hover: el estado base ya se ve completo (borde, ícono y rótulo). El
 *   hover solo refuerza. En un teléfono no hay hover.
 *
 * COPY
 * Escrito para el técnico en obra: verbos de lo que va a hacer con el teléfono,
 * cero vocabulario del sistema ("IA", "extraer", "procesar", "inteligente"). La
 * nota de abajo existe para que nadie crea que envía a ciegas: lo que se dicta o
 * se fotografía se revisa antes de mandarlo.
 *
 * @module pages/technician/materials/QuickRequestShortcut
 */

import React from 'react';
import { Link } from 'react-router-dom';
import './MaterialRequestForm.css';

const QuickRequestShortcut = () => (
  <section
    className="quick-request-shortcut"
    aria-label="Pedir material sin llenar el formulario"
  >
    <p className="quick-request-shortcut-title">Pedir sin llenar el formulario</p>

    <div className="quick-request-shortcut-actions">
      <Link
        to="/tecnico/materiales/smart?modo=dictar"
        className="quick-request-shortcut-btn"
      >
        <i className="bi bi-mic-fill" aria-hidden="true"></i>
        <span>Dictar la lista</span>
      </Link>
      <Link
        to="/tecnico/materiales/smart?modo=foto"
        className="quick-request-shortcut-btn"
      >
        <i className="bi bi-camera-fill" aria-hidden="true"></i>
        <span>Tomarle una foto</span>
      </Link>
    </div>

    <p className="quick-request-shortcut-hint">
      La lista se arma sola y se puede revisar antes de enviar.
    </p>
  </section>
);

export default QuickRequestShortcut;
